var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16159",
    "data-name": "Rectangle 16159",
    width: 65.322,
    height: 66.986,
    fill: "#29bcc1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15770",
    "data-name": "Group 15770",
    transform: "translate(5720 560)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_661",
    "data-name": "Ellipse 661",
    cx: 62,
    cy: 62,
    r: 62,
    transform: "translate(-5720 -560)",
    fill: "#bef5f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15458",
    "data-name": "Group 15458",
    transform: "translate(-5691 -536.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15458-2",
    "data-name": "Group 15458",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41216",
    "data-name": "Path 41216",
    d: "M77.166,67.206c-1.556-1.394-3.091-2.748-4.6-4.127-2.822-2.571-5.932-2.584-8.751-.037-1.519,1.371-3.062,2.715-4.613,4.088-2.489-2.272-4.952-4.52-7.415-6.77-1.078-.985-2.172-1.955-3.219-2.973a1.455,1.455,0,0,1-.407-.936c-.023-7,.015-14-.041-21a2.265,2.265,0,0,1,2.47-2.486c10.9.033,21.81.018,32.715.018.916,0,1.832-.01,2.748,0a2.008,2.008,0,0,1,2.142,2.181q.007,10.727,0,21.454a1.273,1.273,0,0,1-.31.855q-5.2,4.785-10.433,9.527c-.063.057-.139.1-.278.2m-5.1-21.359c2.486,0,4.971.009,7.457,0a1.953,1.953,0,1,0,.054-3.894q-7.489-.027-14.979.014a2.577,2.577,0,0,0-1.37.493,1.763,1.763,0,0,0-.572,2.053,1.876,1.876,0,0,0,1.888,1.33c2.507.016,5.015.006,7.522.007m-.04,7.851c2.485,0,4.971.007,7.457,0a1.956,1.956,0,1,0,.069-3.9c-4.971-.017-9.942-.021-14.913.015a2.672,2.672,0,0,0-1.428.511,1.756,1.756,0,0,0-.547,2.06,1.891,1.891,0,0,0,1.906,1.307c2.485.014,4.971,0,7.457.006M58.61,43.9a1.961,1.961,0,1,0-1.962,1.941A1.971,1.971,0,0,0,58.61,43.9m0,7.875a1.961,1.961,0,1,0-1.986,1.918,1.969,1.969,0,0,0,1.986-1.918",
    transform: "translate(-35.507 -24.329)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41217",
    "data-name": "Path 41217",
    d: "M69.455,181.674H9.1c.146-.161.24-.285.354-.386q11.965-10.61,23.932-21.216,2.178-1.931,4.352-3.866a2.1,2.1,0,0,1,3.277,0q13.955,12.506,27.906,25.017c.127.114.262.221.538.453",
    transform: "translate(-6.711 -114.689)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41218",
    "data-name": "Path 41218",
    d: "M190.927,138.894l-20.714-18.568,20.714-18.958Z",
    transform: "translate(-125.605 -74.802)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41219",
    "data-name": "Path 41219",
    d: "M20.756,119.83,0,138.226v-37.37L20.756,119.83",
    transform: "translate(0 -74.424)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41220",
    "data-name": "Path 41220",
    d: "M216.158,79.535V68.192l6.752,5.164-6.752,6.178",
    transform: "translate(-159.509 -50.321)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41221",
    "data-name": "Path 41221",
    d: "M14.308,79.4,7.639,73.309l6.669-5.1Z",
    transform: "translate(-5.637 -50.33)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41222",
    "data-name": "Path 41222",
    d: "M112.452,4.718H99.113l-.127-.147a4.127,4.127,0,0,0,.417-.249q2.444-1.863,4.881-3.733a2,2,0,0,1,2.792-.037q2.5,1.9,4.987,3.81c.1.077.187.17.388.356",
    transform: "translate(-73.045 0)",
    fill: "#29bcc1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.2076562a4668b72ae51e8c040b3fda53.svg";
export { ForwardRef as ReactComponent };